const getStatusDetails = (statusCode) => {
  const statusMap = {
    1: { name: "Available", color: "green" },
    2: { name: "Busy", color: "goldenrod" },
    3: { name: "Out of Office", color: "red" },
    4: { name: "On Vacation", color: "blue" },
  };
  return statusMap[statusCode] || { name: "", color: "black" };
};

const UserStatusText = ({ status }) => {
  const { name, color } = getStatusDetails(status);

  return <span style={{ color }}>{name}</span>;
};

export default UserStatusText;


